import { useState, useEffect } from "react"
import Cim from "../../../Cim"
import Modal from "../../../components/Modal"
import DataTable from "../../../components/DataTable"
import AkcioTermekek from "./AkcioTermekek"
import AkcioModosit from "./AkcioModosit"
import AkcioFelvitel from "./AkcioFelvitel"
import Kereses from "../../../components/Kereses";
import Rendezes from "../../../components/Rendezes";
import { datumFuggveny } from "../../../utils/formazas";
import "../../../components/DataTable.css"

const Akcio = () => {
    const [adatok, setAdatok] = useState([])
    const [keresettAdatok, setKeresettAdatok] = useState([])
    const [tolt, setTolt] = useState(true)
    const [hiba, setHiba] = useState(false)
    const [siker, setSiker] = useState(false)
    const [ures, setUres] = useState(false)
    const [modalOpenTermekek, setModalOpenTermekek] = useState(false)
    const [modalOpenModosit, setModalOpenModosit] = useState(false)
    const [modalOpenHozzaad, setModalOpenHozzaad] = useState(false)
    const [selectedAkcioId, setSelectedAkcioId] = useState(null)
    const [selectedAkcioKedvezmeny, setSelectedAkcioKedvezmeny] = useState(null)
    const [selectedAkcioTipus, setSelectedAkcioTipus] = useState(null)

    const leToltes = async () => {
        try {
            const response = await fetch(Cim.Cim + "/akcioMinden")
            const data = await response.json()

            if (response.ok) {
                setAdatok(data)
                setKeresettAdatok(data)
                setTolt(false)
            } 
            else if (response.status === 404) {
                setUres(true)
                setTolt(false)
            }
            else {
                setHiba(true)
                setTolt(false)
            }
        } catch (error) {
            console.log(error)
            setHiba(true)
            setTolt(false)
        }
    }

    useEffect(() => {
        leToltes()
    }, [siker])

    const torlesFuggveny = async (rowData) => {
        const biztos = window.confirm(`Biztosan törölni szeretnéd a(z) ${rowData.akcio_nev} akciót?`)

        if (biztos) {
            const response = await fetch(Cim.Cim + "/akcioTorles/" + rowData.akcio_id, {
                method: "DELETE",
                headers: { "Content-Type": "application/json" }
            })

            const data = await response.json()

            if (response.ok) {
                alert(data["message"])
                setSiker(prev => !prev)
            } else {
                alert(data["error"])
            }
        }
    }

    const handleViewTermekek = (rowData) => {
        setSelectedAkcioId(rowData.akcio_id)
        setSelectedAkcioKedvezmeny(rowData.akcio_kedvezmeny)
        setSelectedAkcioTipus(rowData.akcio_tipus)
        setModalOpenTermekek(true)
    }

    const closeModalTermekek = (frissit) => {
        setModalOpenTermekek(false)
        if (frissit) {
            leToltes()
        }
    }
    
    const handleEdit = (rowData) => {
        setSelectedAkcioId(rowData.akcio_id)
        setModalOpenModosit(true)
    }

    const closeModalModosit = (frissit) => {
        setModalOpenModosit(false)
        setSelectedAkcioId(null)
        if (frissit) {
            leToltes()
        }
    }

    const handleAdd = () => {
        setModalOpenHozzaad(true)
    }

    const closeModalHozzaad = (frissit) => {
        setModalOpenHozzaad(false)
        if (frissit) {
            leToltes()
        }
    }

    if (tolt)
        return <div className="text-center">Adatok betöltése folyamatban...</div>
    
    if (hiba)
        return <div className="text-center">Hiba történt az adatok betöltése közben.</div>
    
    if (ures)
        return (
            <div className="container">
                <div className="row justify-content-center mb-3">
                    <div className="col-5"></div>
                    <div className="col-2 text-center">Nincs adat!</div>
                    <div className="col-5 text-center">
                        <button
                            className="btn btn-alert ml-2"
                            onClick={() => handleAdd()}>
                            Új akció felvitele
                        </button>
                    </div>
                </div>
                <Modal isOpen={modalOpenHozzaad} onClose={() => closeModalHozzaad(false)} isWide={true}>
                    <AkcioFelvitel onClose={closeModalHozzaad} />
                </Modal>
            </div>
        )

    // DataTable oszlopok konfigurálása
    const columns = [
        {
            key: 'akcio_nev',
            label: 'Akció neve',
        },
        {
            key: 'akcio_kedvezmeny',
            label: 'Akció',
            render: (rowData) => (
                <div className="d-inline">{rowData.akcio_kedvezmeny}{rowData.akcio_tipus === "szazalek" ? "%" : "Ft"}</div>
            ),
        },
        {
            key: 'akcio_kezdete',
            label: 'Kezdete',
            formatter: (value) => datumFuggveny(value),
        },
        {
            key: 'akcio_vege',
            label: 'Vége',
            formatter: (value) => datumFuggveny(value),
        }
    ]

    // DataTable konfiguráció
    const tableConfig = {
        data: keresettAdatok,
        columns: columns,
        visibleColumnsSmall: ['akcio_nev'],  // Kis képernyőn csak az akció neve legyen látható
        hiddenColumns: [],  // Nagy képernyőn az összes oszlop látható legyen
        actions: {
            view: true,  // Termékek megtekintése
            edit: true,
            delete: true,
            add: true,
        },
        onView: handleViewTermekek,
        onEdit: handleEdit,
        onDelete: torlesFuggveny,
        onAdd: handleAdd,
        primaryKey: 'akcio_id',
    }

    return (
        <div className="container">
            <div className="row justify-content-center mb-3">
                <div className="col-6 text-center">
                    <Kereses adatok={adatok} keresettMezok={["akcio_nev"]} setKeresettAdatok={setKeresettAdatok} />
                </div>
                <div className="col-4 text-center">
                    <Rendezes adatok={keresettAdatok} setKeresettAdatok={setKeresettAdatok}>
                        <option value="akcio_nev|1">Akció neve növekvő</option>
                        <option value="akcio_nev|2">Akció neve csökkenő</option>
                        <option value="akcio_kezdete|1">Akció kezdete növekvő</option>
                        <option value="akcio_kezdete|2">Akció kezdete csökkenő</option>
                        <option value="akcio_vege|1">Akció vége növekvő</option>
                        <option value="akcio_vege|2">Akció vége csökkenő</option>
                    </Rendezes>
                </div>
            </div>

            <DataTable config={tableConfig} />

            <Modal isOpen={modalOpenTermekek} onClose={() => closeModalTermekek(false)}>
                <AkcioTermekek akcio_id={selectedAkcioId} akcio_kedvezmeny={selectedAkcioKedvezmeny} akcio_tipus={selectedAkcioTipus} onClose={closeModalTermekek} />
            </Modal>
            <Modal isOpen={modalOpenModosit} onClose={() => closeModalModosit(false)} isWide={true}>
                <AkcioModosit akcio_id={selectedAkcioId} onClose={closeModalModosit} />
            </Modal>
            <Modal isOpen={modalOpenHozzaad} onClose={() => closeModalHozzaad(false)} isWide={true}>
                <AkcioFelvitel onClose={closeModalHozzaad} />
            </Modal>
        </div>
    )
}

export default Akcio